import { useState, useEffect } from "react";
import EndPoints from "../net/EndPoints";
import React from "react";
import { Grow, Button, Typography } from "@material-ui/core";
import Welcome from "../onboarding/Welcome";
import FullScreenLoader from "../views/FullScreenLoader";
import UsersManager from "../managers/UsersManager";
import axios from 'axios'
import Routes from "../constants/Routes";
import { Redirect } from "react-router-dom";
import ErrorAlert from '@iconify/icons-mdi/alert';
import { InlineIcon } from "@iconify/react";
import ExceptionUtils from "../utils/ExceptionUtils";

export default function DefaultHome() {

    const [initData, setInitData] = useState<{} | undefined>(undefined)
    const [loading, setLoading] = useState(true);
    const [loggedIn, setLoggedIn] = useState(false);
    const [displayErrorPage, setDisplayErrorPage] = useState(false);
    const [errorMessage, setErrorMessage] = useState("");

    function reloadPage() {
        window.location.reload();
    }

    const handleKeyEvent = (event: KeyboardEvent) => {
        if (event.keyCode === 13) {
            reloadPage();
        }
    }

    const initErrorPage = () => {
        return <div style={{
            display: 'flex',
            flexDirection: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100vh'
        }}>
            <InlineIcon icon={ErrorAlert} width={80} height={80} style={{
                color: '#999999'
            }} />
            <Typography>{`${errorMessage}`}</Typography>
            <Button color="secondary" onClick={reloadPage}
                onKeyDown={(event) => {
                    handleKeyEvent(event as unknown as KeyboardEvent)
                }}>Please, Reload Page</Button>
        </div>
    }

    function initApp() {
        axios.get(EndPoints.INIT).then((data: any) => {
            let result = data["data"]["data"];
            setInitData(result);
            setLoading(false);
        }).catch((error) => {
            let message = ExceptionUtils.getErrorMessage(error);
            setErrorMessage(message);
            setDisplayErrorPage(true);
        });
    }

    useEffect(() => {
        let loggedInUser: any = UsersManager.getLoggedInUser()
        if (!loggedInUser) {
            initApp();
        } else {
            setLoggedIn(true);
        }
    }, [loading]);

    return (
        loggedIn ?
            <Redirect to={Routes.HOME} />
            :
            displayErrorPage ? initErrorPage() :
                loading ? <FullScreenLoader /> :
                    <div style={{ display: 'flex' }}>
                        <Grow in={true}
                            style={{ transformOrigin: '0 0 0' }}
                            {...({ timeout: 50000 })}>
                            <Welcome data={initData} />
                        </Grow>
                    </div>
    );
}